import { useMemo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

export default function GeographicSalesIntelligenceDistance({ buckets }) {
  const options = useMemo(() => {
    const rows = buckets || []
    return {
      chart: {
        type: 'bar',
        height: 280,
        backgroundColor: 'transparent',
        spacing: [8, 8, 8, 8],
      },
      title: { text: undefined },
      credits: { enabled: false },
      legend: { enabled: false },
      xAxis: {
        categories: rows.map((bucket) => `${bucket.label} mi`),
        lineColor: '#e5e7eb',
        tickColor: '#e5e7eb',
        labels: { style: { color: '#6b7280', fontSize: '12px' } },
      },
      yAxis: {
        min: 0,
        title: { text: null },
        gridLineColor: '#eef0f2',
        labels: { enabled: false },
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b> buyers ({point.percent}%)',
      },
      plotOptions: {
        bar: {
          borderWidth: 0,
          color: '#3E8BF7',
          dataLabels: {
            enabled: true,
            format: '{point.percent}%',
            style: { fontSize: '11px', fontWeight: '600', textOutline: 'none' },
          },
        },
      },
      series: [
        {
          name: 'Buyers',
          data: rows.map((bucket) => ({
            y: Number(bucket.buyers) || 0,
            percent: Number(bucket.percent) || 0,
          })),
        },
      ],
    }
  }, [buckets])

  if (!buckets?.length || buckets.every((bucket) => !bucket.buyers)) {
    return (
      <p className="text-muted small mb-0">
        Distance is stored when an order is created and both buyer and venue
        coordinates are available.
      </p>
    )
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />
}
